export default __webpack_public_path__ + "static/media/product-page-example.bb844af1.jpg";